// Match a numeric value against a normative cell string from a parquet table.
// Supports:
//   ">= N", "<= N", "> N", "< N"
//   "X-Y" or "X–Y" (en-dash) — value within bounds, order tolerant, negatives OK
//   "A/B/C"                  — value equals one of the listed numbers
//   "N"                      — exact equality (value === parseFloat(N))
// Returns false for null/empty/unparseable.
export function matchesRange(value, rangeStr) {
  if (rangeStr == null) return false;
  const s = String(rangeStr).trim();
  if (!s) return false;

  const ge = s.match(/^>=\s*(-?\d+(?:\.\d+)?)/);
  if (ge) return value >= parseFloat(ge[1]);

  const le = s.match(/^<=\s*(-?\d+(?:\.\d+)?)/);
  if (le) return value <= parseFloat(le[1]);

  const gt = s.match(/^>\s*(-?\d+(?:\.\d+)?)/);
  if (gt) return value > parseFloat(gt[1]);

  const lt = s.match(/^<\s*(-?\d+(?:\.\d+)?)/);
  if (lt) return value < parseFloat(lt[1]);

  if (s.includes("/")) {
    const parts = s.split("/").map((p) => parseFloat(p.trim()));
    if (parts.every(Number.isFinite)) return parts.includes(value);
  }

  const range = s.match(/^(-?\d+(?:\.\d+)?)\s*[-–]\s*(-?\d+(?:\.\d+)?)/);
  if (range) {
    const a = parseFloat(range[1]);
    const b = parseFloat(range[2]);
    return value >= Math.min(a, b) && value <= Math.max(a, b);
  }

  const num = parseFloat(s);
  if (!Number.isNaN(num)) return value === num;

  return false;
}
